import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(response => {
        let data = response.data

        data.forEach(function (d) {
            d.dim1_name = new Date(d.dim1_name);
            d.metric1 = +d.metric1;
            d.metric2 = +d.metric2;
        });

        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim1_name;
            })
            .rollup(v => {
                return {
                    value1: d3.sum(v, function (d) {
                        return d.metric1;
                    }),
                    value2: d3.sum(v, function (d) {
                        return d.metric2;
                    })
                }
            })
            .entries(data);

        var expenseMetrics = d3.nest()
            .entries(dataXAxis)
            .map(function (group) {
                return {
                    key: group.key,
                    value1: group.value.value1,
                    value2: group.value.value2,
                }
            });

        console.log(expenseMetrics, "New line");
        /* expenseMetrics.forEach(y => {
                y.dim1_name = y.key;
                y.values.forEach(d => {
                     d.metric1=+d.value1
                     d.metric2 = +d.value2;
                });
                y.values.sort((a, b) =>{ return b.metric1- a.metric1 });
         });*/

        var formatTime = d3.timeFormat("%Y-%m");
        // Set the x and y values
        // var x1Scale = d3.scaleLinear().range([0, chart.width]);
        var x1Scale = d3.scaleTime().range([0, chart.width]);
        var y1Scale = d3.scaleLinear().range([chart.height, 0]);
        var y2Scale = d3.scaleLinear().range([chart.height, 0]);

        // Define the axes
        var x1AxisLabel = d3.axisBottom(x1Scale).tickFormat(formatTime);

        var y1AxisLabel = d3.axisLeft(y1Scale).tickFormat(numberFormat);

        var y2AxisLabel = d3.axisRight(y2Scale).tickFormat(numberFormat);

        // Define the line
        var dataline = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name);
            })
            .y(function (d) {
                return y1Scale(d.metric1);
            });

        var dataline2 = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name);
            })
            .y(function (d) {
                return y2Scale(d.metric2);
            });

        var svg = d3.select(divId).select("svg").remove();
        // Adds the canvas
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .attr("font", "Arial")
            .style("font-size", "14px")
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        // Nest the entries by symbol
        var dNest = d3.nest().key(function (d) {
            return d.dim2_name;
        }).entries(data);

        // set the colour scale
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);
        var metric2ColorScale = d3.scaleOrdinal().domain([chart.y1DataFieldName, chart.y2DataFieldName])
        //metric1ColorScale.domain(dNest);
        console.log(metric1ColorScale)

        // var xdim=function(d){ return d.metric1<1 ? -1: d3.min(data, function (d) { return d.metric1})}

        x1Scale.domain(d3.extent(data, function (d) {
            return d.dim1_name;
        }));
        y1Scale.domain([d3.min(data, function (d) {
            return d.metric1 < 1 ? -1 : d.metric1
        }),
            d3.max(data, function (d) {
                return d.metric1;
            })]);
        y2Scale.domain([d3.min(data, function (d) {
            return d.metric2;
        }),
            d3.max(data, function (d) {
                return d.metric2;
            })]);

        // spacing for the legend
        var legendSpace = chart.width / dNest.length;

        console.warn(legendSpace)
        // Add the X Axis
        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom + 15 + chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + chart.width + " ,0)")
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y', chart.width + chart.margin.right - 100)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)

        // Loop through each symbol / key
        dNest.forEach(function (d) {
            var lines = svg.append("path")
                .attr("class", "line")
                .attr("fill", "none")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric1ColorScale = metric1ColorScale(d.key);
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 3)
                .attr("d", dataline(d.values))
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            console.warn(lines)

            var lines2 = svg.append("path")
                // .attr("class", "line")
                .attr('class', 'plotdashed')
                .attr("fill", "none")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric1ColorScale = metric1ColorScale(d.key);
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 3)
                .attr("d", dataline2(d.values))

            console.warn(lines2)

            // Add the dots for the tooltip

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            svg.selectAll("dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x1Scale(d.dim1_name);
                })
                .attr("cy", function (d) {
                    return y1Scale(d.metric1);
                })
                // .style("fill","blue")
                .style("fill", d => {
                    return metric1ColorScale(d.dim2_name)
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim1_name) +
                        "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1)
                    )
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            svg.selectAll("dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x1Scale(d.dim1_name);
                })
                .attr("cy", function (d) {
                    return y2Scale(d.metric2);
                })
                .style("fill", d => {
                    return metric1ColorScale(d.dim2_name)
                })
                //   .style("fill","blue")
                // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim1_name) +
                        "<br/>" + chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric2)
                    )
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y2tip.show)
            //.on("mouseout", y2tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        });

        var y1legend = svg.selectAll('.legend')
            .data(metric2ColorScale.domain())
            .enter().append('g')
            .attr('class', 'legend')
            //.attr("transform", function (d, i) { return "translate(30," + i * 25 + ")"; });
            .attr('transform', function (d, i) {
                var horz = 180 * i; // NEW
                var vert = 100;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });
        y1legend.append('line')
            .attr("x1", 0)
            .attr("x2", 40)
            .attr("y1", chart.height + 20)
            .attr("y2", chart.height + 20)
            .attr("stroke-width", 3)
            .attr("stroke", "black")
            // .attr("stroke-opacity", "3")
            .attr("class", function (d) {
                if (d.startsWith(chart.y2MetricTooltip)) {
                    return 'plotdashed';
                } else {
                    return 'plotline';
                }
            })

        y1legend.append('text')
            .attr('x', 50)
            .attr('y', chart.height + 10 * chart.vizSpecific1 + 20)
            //.attr('dy', '.1em')
            //.style('fill', metric1ColorScale)
            .style('font-size', "18px")
            .text(function (d) {
                // if (d.length > 10)
                //     return d.substring(0, 7)
                // else {
                return d
                //  }
            })


        var y2legend = svg.append('g')
            .selectAll('g')
            .data(metric1ColorScale.domain())
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 250 * i; // NEW
                var vert = 25;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y2legend.append('rect')
            .attr('x', 10)
            .attr('y', chart.height + 120)
            .attr('width', 20)
            .attr('height', 20)
            .attr('fill', d => {
                return metric1ColorScale(d)
            })

        y2legend.append('text')
            .attr('x', 40)
            .attr('y', chart.height + 120)
            .attr('dy', '0.75em')
            .text((d) => {
                return d
            })
            .style('font-size', "25px")

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

    });
}
